export const SAVE_ALL_EXPENSES = 'SAVE_ALL_EXPENSES'